// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__xEeGU","topBottomGutter":"Layout_topBottomGutter__1pWjg"};